export * from "./apply-default-seo";
